import { Button, Card, Container, Typography } from "@mui/material";

/**
 * * Page Not Found error page for website
 * @returns {React.ReactElement} PageNotFound
 */
export default function PageNotFound() {
  return (
    <Container
      id="404-page"
      data-testid="404-page"
      maxWidth="sm"
      align="center"
      sx={{ py: 10, px: 2 }}
    >
      <Card
        sx={{ p: 2, backgroundColor: "#fafafa", borderRadius: 4 }}
        elevation={0}
      >
        <Typography variant="h1" color="secondary" pb={2}>
          404
        </Typography>
        <Typography variant="h3" color="secondary" fontWeight="normal" pb={4}>
          Page Not Found
        </Typography>
        <Button href="/" variant="outlined" color="secondary">
          Go Home
        </Button>
      </Card>
    </Container>
  );
}
